import { render, staticRenderFns } from "./TifVentanaGeneralOperacionesTurnos.vue?vue&type=template&id=31ebc43e"
import script from "./TifVentanaGeneralOperacionesTurnos.vue?vue&type=script&lang=js"
export * from "./TifVentanaGeneralOperacionesTurnos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports